class EventView {
	constructor(instance,layerView, visible) {
		this._instance = instance;
		this._layerView = layerView;

		this._elem = UI.div('timelineEvent norm', [
			this._eventTopper,
			UI.div('activity-content', [
				this.graphic = UI.img('activity-graphic'),
				UI.div(null, [this.text = UI.span()]),
				this.icons = UI.div('activity-icons', [
					this.groupIcon = UI.span('icon hide', '<i class="i-rg i-group"></i>'),
					this.repeatIcon = UI.span('icon hide', '<i class="i-rg i-repeat"></i>'),
					this.linkIcon = UI.span('icon hide', '<i class="i-rg i-resources"></i>')
				])
			]),
			UI.div('event-resize-left'),
			UI.div('event-resize-right')
		], {
			'mousedown touchstart': this.mousedown.bind(this, MOVE_BOTH),
			'mouseover': this.mouseover.bind(this),
			'mouseout': this.mouseout.bind(this)
		});

		this.onActivityChange();
		this.visible = visible;
	}

	get elem() {
		return this._elem;
	}

	get event() {
		return this._instance.event;
	}

	/**
	 * @param {boolean} v
	 */
	set visible(value) {
		this._elem.style.display = value ? 'block' : 'none';
		if (value) {
			this.resize();
			this.update();
		}
	}

	set active (value) {
		state(this._elem, value ? 'active' : 'norm');
	}

	get layerView() {
		return this._layerView;
	}

	mouseover() {
		this._instance.mouseover(this);
	}

	mousedown(action, event) {
		this._instance.mousedown(action, event);
	}

	mouseout(event) {
		if (this._elem.contains(event.toElement)) return;
		globalTimeline.hideEventDetails();
	}

	onActivityChange() {
		if (this.event.activity.hasGraphic()) {
			this.graphic.src = graphicSrc(this.event.graphicId);
		}
		else {
			this.graphic.src = graphicSrc(0);
		}
		this.text.innerText = this.event.activity.text;
		this._elem.style.color = getContrastColor(this.event.color);
		this._elem.style.backgroundColor = this.event.color;
		state(this.repeatIcon, (this.event.isRepeated) ? 'norm' : 'hide');
		state(this.linkIcon, (this.event.activity.itemCount) ? 'norm' : 'hide');
		this.resize();
	}

	resize() {
		let width = Math.ceil(this._instance.duration / this._layerView.timeline.millisecondPerPixel);
		this._elem.style.width = width + 'px';
		let graphicVisible = false;
		if (this.event.activity) {
			if (this.event.activity.hasGraphic()) {
				if (width > 50) graphicVisible = true;
				this.graphic.style.display = graphicVisible ? 'inline-block' : 'none';
			}
			else {
				this.graphic.style.display = 'none';
			}
		}
		else {
			this.graphic.style.display = 'none';
		}
		if (graphicVisible) {
			this.icons.style.display = (width > 80) ? 'inline-block' : 'none';
		}
		else {
			this.icons.style.display = (width > 40) ? 'inline-block' : 'none';
		}
	}

	update() {
		let left = this._layerView.timeline.timeToOffset(this._instance.startTime);
		this._elem.style.left = left + 'px';
	}

}